import Vue from 'vue'
import Router from 'vue-router'

import login from '@/page/login'
import home from '@/page/home'
import code from '@/page/code'
import variety from '@/page/variety'
import company from '@/page/company'
import appletAdministrator from "./page/appletAdministrator"
import firstAgent from "./page/firstAgent";

Vue.use(Router)

//引入axios
import axios from 'axios'
import vueAxios from 'vue-axios'
import Qs from "qs";

Vue.use(vueAxios, axios)

// 根据运行环境决定BaseURL地址
if (window.location.host === "127.0.0.1:8000") {
  //本地
  axios.defaults.baseURL = 'http://127.0.0.1:8000/api/'
} else {
  // 万物追溯 baseURL
  axios.defaults.baseURL = 'https://api.wwzhuisu.cn/api/'
}


//设置跨域请求(允许携带cookie)
axios.defaults.withCredentials = true
//进行POST请求的时候将数据格式改变
axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded'
axios.defaults.transformRequest = [function (data) {
//    对data进行数据转化
  return Qs.stringify(data)
}]

//进行登录状态验证
function checkStatus(to, from, next) {
  //使用sessionLocalStorage验证登录，如果sessionStorage不存在则直接跳转到登录页面
  axios.post('administrator/verifyLogin').then(success => {
    //如果登录成功直接到想跳转的页面上去
    if (success.data.errno === 0) {
      sessionStorage.setItem('info', JSON.stringify(success.data.data))
      next()
    } else {
      //如果网页不是从  根目录进行跳转，那么就弹出提示框
      if (from.path != '/') {
        alert('登录已过期，请重新登录！')
      }
      next({path: '/login'})
    }
  })
}

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      beforeEnter: checkStatus,
      redirect: '/login',
    },
    {
      path: '/home',
      component: home,
      beforeEnter: checkStatus,
      redirect: '/home/company',
      children: [
        {
          path: 'code',
          beforeEnter: checkStatus,
          component: code,
        },
        {
          path: 'variety',
          beforeEnter: checkStatus,
          component: variety,
        },
        {
          path: 'company',
          beforeEnter: checkStatus,
          component: company,
        },
        {
          path: 'appletAdministrator',
          beforeEnter: checkStatus,
          component: appletAdministrator,
        },
        {
          path: 'firstAgent',
          beforeEnter: checkStatus,
          component: firstAgent,
        },
      ]
    },
    {
      path: '/login',
      component: login
    },
  ]
})



// WEBPACK FOOTER //
// ./src/router.js